import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';

const IndexPage = lazy(() => import('src/pages/oss-supervisor/index'));
const ApprovalPage = lazy(() => import('src/pages/oss-supervisor/[caseID]/approval'));


export const OssSupervisorRoutes = [
    {
        path: 'ossSupervisor',
        element: (
            <AppLayout>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </AppLayout>
        ),
        children: [
            {
                index: true,
                element: <IndexPage/>
            },
            {
                path: ':id/approval',
                element: <ApprovalPage/>
            },
        ]
    }
];
